import React from 'react';
import withIcon from '../utilities/withIcon';

const IconPlus = () => {
  return (
    <g>
      <path d="m15.2012 7.25h-6.4512v-6.4512a.75.75 0 0 0 -1.5 0v6.4512h-6.4512a.75.75 0 0 0 0 1.5h6.4512v6.4512a.75.75 0 0 0 1.5 0v-6.4512h6.4512a.75.75 0 0 0 0-1.5z" />
    </g>
  );
};

export default withIcon(IconPlus);
